export default __webpack_public_path__ + "static/media/sound-on.378c86c9.png";